<template>
  <div class="container">
      <div class="topView">
          <img src="../../assets/images/househomeTop.jpeg" class="topImage"/>
      </div>
      <div class="bodyView">
          <div class="bodyItem" v-for="(item,index) in iconList" :key="index" @click="pushtoIndex(index)">
              <img v-if="item.imgUrl" :src="item.imgUrl" class="bodyItemIcon" />
              <img v-else src="../../assets/images/houseHomeIcon.jpeg" class="bodyItemIcon" />
              <span class="bodyItemSpan">{{item.type}}</span>
          </div>

      </div>
      <div class="bottomView">
          <img src="../../assets/images/houseHomeBottom.jpeg" class="bottomImage"/>
      </div>
      <div class="bottomLine"></div>


  </div>
</template>

<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import { getIntServTemplateByMarketId } from "../../utils/api.js";
export default {
  name: "homePage",
  components: {
  },
  data() {
    return {
      iconList: ""
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getIntServTemplateByMarketId();
  },
  methods: {
      pushtoIndex(index){
        var link =  "/houseKeeping"+"?index="+index;
        this.$router.push(link);
      },
      // 获取数据
      getIntServTemplateByMarketId() {
        util.showLoading();
        getIntServTemplateByMarketId({}).then(res => {
            console.log(res);
            if (res.res.code === 10000 && res.body && res.body.intServTemplate) {
                this.iconList = res.body.intServTemplate
                util.hideLoading();
            } else {
                 util.hideLoading();
                 util.showModal('','项目暂未开启服务',false,'我知道了',()=>{
                    this.$router.go(-1)
                 })
            }
        });
      }
  }
  };
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #FFFFFF;
}
.topView{
    width: 750px;
    height: 224px;
    .topImage{
        width: 750px;
        height: 224px;
    }
}

.bodyView{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-left: 20px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 60px;
    width:710px;
    // height:588px;
    background:rgba(255,255,255,1);
    box-shadow:0px 8px 32px 0px rgba(232,238,236,1);
    border-radius:16px;
}
.bodyItem{
    margin-left: 42.5px;
    margin-top: 60px;
    width: 180px;
    height: 204px;
    display: flex;
    flex-direction: column;
    // background-color: red;
    .bodyItemIcon{
        margin-left: 20px;
        width: 140px;
        height: 140px;
        border-radius:70px;
    }
    .bodyItemSpan{
        margin-top: 22px;
        width: 180px;
        height: 42px;
        font-size:30px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:42px;
        text-align: center;
        white-space:nowrap;
        overflow: hidden;
    }

}

.bottomView{
    margin-left: 20px;
    margin-top: 60px;
    width:710px;
    height:346px;
    // background:rgba(246,251,249,1);
    // border-radius:16px;
    // border:2px solid rgba(223,238,233,1);
    .bottomImage{
        width:710px;
        height:346px;
    }
}
.bottomLine{
    width:750px;
    height:40px;
    display: flex;
}


</style>